<div class="modal-header">
  <h5 class="modal-title">Install OS Update</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div>
    <select ngbAutofocus
            [(ngModel)]="installAction"
            class="form-select">
      <option [ngValue]="'Default'">Default</option>
      <option [ngValue]="'DownloadOnly'">Download only</option>
      <option [ngValue]="'InstallASAP'">Install ASAP</option>
      <option [ngValue]="'NotifyOnly'">Notify only</option>
      <option [ngValue]="'InstallLater'">Install later</option>
    </select>
  </div>
</div>
<div class="modal-footer">
  <button type="submit"
          class="btn btn-primary align-self-end"
          (click)="installUpdate()">
    <fa-icon icon="file-upload"></fa-icon>
    <span class="ms-2"
          i18n>Install</span>
  </button>
</div>